import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

import { NHG } from '../../../Enum/Filters/';
import { Filter } from '../../../Enum/Filters';

import { filterChanged } from '../../../Store/Filter/action';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';

const NHGFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.NHG);

    const selectNHG = useCallback(
        (nhg: NHG): void => {
            dispatch(filterChanged(Filter.NHG, nhg));
        },
        [dispatch],
    );

    return (
        <>
            <Form className="nhg-filter" autoComplete="off">
                <Form.Group controlId="nhg">
                    <Form.Label>Verstrekking met NHG</Form.Label>
                    <InputGroup>
                        <Form.Check
                            custom
                            checked={value === NHG.Ja}
                            onChange={() => selectNHG(NHG.Ja)}
                            type="radio"
                            label="Ja"
                            id="nhgFilter1"
                        />
                        <Form.Check
                            custom
                            checked={value === NHG.Nee}
                            onChange={() => selectNHG(NHG.Nee)}
                            type="radio"
                            label="Nee"
                            id="nhgFilter2"
                        />
                    </InputGroup>
                </Form.Group>
            </Form>
        </>
    );
};

export default NHGFilter;
